import React from "react";
import { useLang } from "../i18n";
import { Check, X, Salad } from "lucide-react";
import { PROTOCOL_FOODS } from "../constants/protocolFoods";

export function ProtocolCard() {
  const { t, lang } = useLang();
  const prefer = PROTOCOL_FOODS.prefer[lang] || PROTOCOL_FOODS.prefer.it;
  const avoid = PROTOCOL_FOODS.avoid[lang] || PROTOCOL_FOODS.avoid.it;

  return (
    <div className="rounded-2xl p-6 mb-8 bg-white border border-stone-200" data-testid="protocol-foods">
      <div className="flex items-center gap-2 mb-5 text-[#3F6E85]">
        <Salad className="w-5 h-5 text-[#3B604E]" />
        <h3 className="font-serif text-2xl tracking-tight">{t("protocol_foods_title")}</h3>
      </div>
      <div className="grid sm:grid-cols-2 gap-5">
        <div className="rounded-xl p-4 bg-[#EAF0EC] border border-[#cfe0d6]">
          <p className="flex items-center gap-2 text-sm font-semibold text-[#3B604E] mb-3">
            <Check className="w-4 h-4" /> {t("protocol_prefer")}
          </p>
          <ul className="space-y-1.5">
            {prefer.map((f, i) => (
              <li key={i} className="flex gap-2 text-sm text-[#2f4a3d]">
                <span className="text-[#3B604E] mt-0.5">›</span> {f}
              </li>
            ))}
          </ul>
        </div>
        <div className="rounded-xl p-4 bg-[#FBEDE7] border border-[#f2d6cb]">
          <p className="flex items-center gap-2 text-sm font-semibold text-[#B7410E] mb-3">
            <X className="w-4 h-4" /> {t("protocol_avoid")}
          </p>
          <ul className="space-y-1.5">
            {avoid.map((f, i) => (
              <li key={i} className="flex gap-2 text-sm text-[#8a3b16]">
                <span className="text-[#B7410E] mt-0.5">›</span> {f}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
